import { makeStyles } from '@material-ui/core';
import styled from 'styled-components';
import appColors from 'utils/appColors';

export const styles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    marginTop: 8,
    minHeight: '100vh',
    backgroundColor: appColors.BACKGROUND_COLOR,
  },
  headerCard: {
    backgroundColor: '#FFFFFF',
    border: '1px solid #E6E8EB',
    borderRadius: 16,
    padding: '12px 16px',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.04)',
    marginBottom: 8,
  },
  unitsAndFiltersRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: 12,
    width: '100%',
  },
  tabsWrapper: {
    flex: '1 1 0',
    minWidth: 0,
    overflow: 'hidden',
    '& .MuiTabs-root': {
      minHeight: 44,
    },
  },
  actionsRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-end',
    gap: 8,
    flex: '0 1 auto',
    minHeight: 44,
    maxWidth: '100%',
  },
  actionButton: {
    border: '1px solid #E3E7EE',
    borderRadius: 10,
    backgroundColor: '#F7F9FC',
  },
  container_pagination: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 20,
  },
  container_no_results: {
    marginTop: 48,
    display: 'flex',
    justifyContent: 'center',
  },
  no_results: {
    fontSize: 18,
    color: '#646464',
  },
  emptyStateCard: {
    marginTop: 20,
    borderRadius: 14,
    padding: '28px 24px',
    backgroundColor: '#FFFFFF',
    border: '1px dashed #C9D2DE',
    textAlign: 'center',
  },
  emptyStateTitle: {
    fontFamily: 'Poppins',
    fontSize: 18,
    color: '#25314A',
    fontWeight: 500,
  },
  emptyStateSubtitle: {
    fontFamily: 'Poppins',
    fontSize: 13,
    color: '#667085',
    marginTop: 6,
  },
}));

export const ScreenContainer = styled.div`
  margin-left: 50px;
  @media (min-width: 1601px) {
    margin-left: 70px;
  }
  @media (max-width: 1600px) {
    margin-left: 20px;
  }
  @media (max-width: 1440px) {
    margin-left: 45px;
  }
  @media (max-width: 1024px) {
    padding-left: 50px;
    margin-top: 5px;
  }
`;

export const DefaultContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  max-width: 100%;
  gap: 16px;
`;
